import { ApplicationRoute } from 'routes/routes.enums';
import { PermissionName } from 'components/permissions/permissions.enum';

import { NavigateItem } from './header.types';

export const HEADER_NAV_ITEMS: NavigateItem[] = [
  {
    label: 'Customer Applications',
    route: ApplicationRoute.Home,
    requiredPermissions: [PermissionName.ConsumerApplication],
  },
  {
    label: 'Account Status',
    route: ApplicationRoute.AccountStatus,
    requiredPermissions: [],
  },
  {
    label: 'Company Profile',
    route: ApplicationRoute.CompanyProfile,
    requiredPermissions: [PermissionName.CompanyInformationView],
  },
  {
    label: 'Company Notifications',
    route: ApplicationRoute.CompanyNotifications,
    requiredPermissions: [PermissionName.CompanyNotificationsUpdate],
  },
];
